export const useAnchorElement = (
  topElement: Ref,
  id: string,
  label?: string
) => {
  const anchorsList = inject(INJECT_ANCHORS, () => useAnchors(ref(0)), true);

  if (!anchorsList) return;

  const { top: position } = useElementBounding(topElement);

  if (anchorsList) {
    anchorsList.setAnchor({
      id,
      label,
      position,
    });
  }
};
